// eslint-disable-next-line import/prefer-default-export
export enum Tier {
  FREE_TRIAL = "FREE_TRIAL",
  OFFICIAL = "OFFICIAL",
  ENTERPRISE = "ENTERPRISE",
}
